import React, { createContext, useContext, useState, useEffect } from "react";
import axios, { AxiosError } from "axios";
import { API_BASE_URL } from "../constants";
import { GameLog, PlayLog } from "../types/StatsTypes";
import { DepthChart, DepthChartPlayer, DepthChartPlayerAssignment, DepthChartPosition } from "../types/DepthChartTypes";
import { useDepthChart } from "./DepthChartContext";


interface StatsContextType {
    playLogs: PlayLog[];
    setPlayLogs: (playLogs: PlayLog[]) => void;
    gameLog: GameLog | null;
    setGameLog: (gameLog: GameLog) => void;
}


const StatsContext = createContext<StatsContextType | undefined>(undefined);


export const StatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [playLogs, setPlayLogs] = useState<PlayLog[]>([]);
    const [gameLog, setGameLog] = useState<GameLog | null>(null);

    return (
        <StatsContext.Provider 
        value={{
            playLogs,
            setPlayLogs,
            gameLog,
            setGameLog,
        }}
        >
            {children}
        </StatsContext.Provider>
    );
};


export const useStats = () => {
    const context = useContext(StatsContext);
    if (context === undefined) {
      throw new Error("useStats must be used within a StatsProvider");
    }
    return context;
  };